import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';

import { DEFAULT_TIMEZONE } from '../constants';

export function getTimeZone(flowAPI: ControllerFlowAPI) {
  const { wixCodeApi } = flowAPI.controllerConfig;
  return wixCodeApi.site.timezone ?? DEFAULT_TIMEZONE;
}
